<!-- filepath: c:\Users\Mayn\Desktop\program\h5\wyg-exam-ui-main\src\components\LoginDialog.vue -->
<template>
  <el-dialog :visible.sync="visible" width="500px" :before-close="handleClose" custom-class="login-dialog" center
    show-close :close-on-click-modal="false">
    <div class="login-dialog-content">
      <!-- 你的登录表单内容 -->
      <login-form @success="handleSuccess" :default-active="activeName" @handleClose="handleClose" />
    </div>
  </el-dialog>
</template>

<script>
import LoginForm from './LoginForm.vue'
export default {
  components: { LoginForm },
  data() {
    return { visible: false, activeName: '/login' }
  },
  created() {
    this.$bus.on('show-login', this.show)
  },
  methods: {
    show(type = 'login') {
      this.activeName = type === 'register' ? '/register' : '/login';


      this.visible = true
    },
    handleClose() { this.visible = false },
    handleSuccess() {
      this.visible = false
      // 登录成功后可做跳转或刷新
      this.$router.replace(this.$route.fullPath)
    }
  }
}
</script>

<style scoped>
.login-dialog ::v-deep .el-dialog__header {
  border-bottom: none;
  text-align: center;
}

.login-dialog-content {
  padding: 20px 10px;
}

.login-dialog ::v-deep .el-dialog {
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
}
</style>